var ContactModalController = function (
    $scope,
    AcctsCustomizationRetrievalService,
    DefaultAcctsCustRetrievalService,
    AccuCodeService
) {
    $scope.footer = {};
    $scope.accu = AccuCodeService.getAccuCode();

    function setAccuData(customizations) {
        angular.extend($scope.footer, customizations.footer);
    }

    DefaultAcctsCustRetrievalService.query(function (data) {
        setAccuData(data);

        AcctsCustomizationRetrievalService.query(
            {
                accu: $scope.accu
            },
            function (data) {
                setAccuData(data);
            }
        );
    });
};

ContactModalController.$inject = [
    "$scope",
    "AcctsCustomizationRetrievalService",
    "DefaultAcctsCustRetrievalService",
    "AccuCodeService"
];
export default ContactModalController;
